import { ApiSimpleComponent } from "@incendium/api";
import { saveComponent } from "features/campaigns";
import { customJsScript } from "features/lightningLanders/constants";
import { LightningLanderThemeSettings } from "features/lightningLanders/types";
import { getCanvasDocument } from "features/lightningLanders/utils";
import { Editor, ProjectData } from "grapesjs";

export interface PersistLanderComponentOptions {
  editor: Editor;
  projectData: ProjectData;
  component: ApiSimpleComponent;
  projectId: number;
  theme?: LightningLanderThemeSettings;
  saveToken?: string;
  includeTheme?: boolean;
  customSaveFunction?: (
    component: ApiSimpleComponent,
    token?: string,
  ) => Promise<{ component?: ApiSimpleComponent }>;
}

export async function persistLanderComponent(
  options: PersistLanderComponentOptions,
): Promise<ApiSimpleComponent> {
  const {
    editor,
    projectData,
    component,
    projectId,
    theme,
    saveToken,
    includeTheme = true,
    customSaveFunction,
  } = options;

  const fullCss = editor.getCss({ keepUnusedStyles: true });
  const canvasDoc = getCanvasDocument(editor);
  const existingScript = canvasDoc?.querySelector(`script[${customJsScript}]`);
  const jsContent = existingScript ? existingScript.textContent || "" : "";

  const componentToSave: ApiSimpleComponent = {
    ...component,
    grapeJs: JSON.stringify(projectData),
    html: editor.getHtml(),
    css: fullCss,
    js: jsContent,
    ...(includeTheme && theme ? { theme: JSON.stringify(theme) } : {}),
  };

  const res = customSaveFunction
    ? await customSaveFunction(componentToSave, saveToken)
    : await saveComponent(projectId, componentToSave, saveToken);

  if (!res.component) {
    throw new Error("Save response did not include component");
  }

  return res.component;
}
